import Rate from './Rate';


Rate.install = function(Vue) {
  Vue.component(Rate.name, Rate);
};

export default Rate;
